﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";


export class GuiDetailEn extends GuiDetailGeneric {
    constructor() {
        super("En");
        $("#btnGotoAktionen").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickGotoAktionen(e));
        $("#VmDetail_SammelNachweis").on("change", () => this.changeSammelnachweis());
        $("#btnCheckEanv").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#VmDetail_GueltigVon, #VmDetail_GueltigBis").on("change", () => this.checkGueltigkeit());

        this.setRequired();
        this.checkGueltigkeit();

    }

    clickGotoAktionen(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickGotoAktionen");

        // Action ändern für anderen Endpunkt
        const action = $(e.currentTarget).data("action") as string;
        $("#detailForm").attr("action", action);
    }

    changeSammelnachweis() {
        this.log("changeSammelnachweis");
        this.setRequired();
    }

    setRequired() {
        if ($("#VmDetail_SammelNachweis").is(':checked')) {
            $("#VmDetail_BefoerdererId").attr("required", "required");
            $("#VmDetail_BefoerdererId").removeAttr("disabled");
        }
        else {
            $("#VmDetail_BefoerdererId").removeAttr("required");
            $("#VmDetail_BefoerdererId").attr("disabled", "disabled");
        }
    }


    // DEVCLR-373: "Gültig von" darf nicht nach "Gültig bis" liegen. Die Meldung hängt am Feld
    // "Gültig bis" und greift damit in form.checkValidity() vor dem Speichern.
    checkGueltigkeit() {
        const von = $("#VmDetail_GueltigVon").val() as string;
        const bisInput = $("#VmDetail_GueltigBis")[0] as HTMLInputElement | undefined;
        if (!bisInput) {
            return;
        }

        // type=date liefert yyyy-MM-dd, der String-Vergleich entspricht dem Datumsvergleich
        const ungueltig = von !== "" && bisInput.value !== "" && von > bisInput.value;
        bisInput.setCustomValidity(ungueltig ? "Gültig bis darf nicht vor Gültig von liegen." : "");
    }

    protected override beforeSave() {
        this.checkGueltigkeit();
    }

    override validateClient() {
        //this.createToastValidate("Validierung", "Beförderer muss gewählt werden.", "warning", 5000);
        return true;
    }
}
